import { useEffect, useState } from "react"
import { Select } from "@planningcenter/doxy-web"
import { Text2GivePhoneNumber } from "../../types"
import { Link } from "react-router-dom"
import { usePaymentMethodsContext } from "../../hooks/usePaymentMethodsContext"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { AlertMessage } from "source/shared/components"
import { useGivingOrganizationContext } from "../../hooks/useGivingOrganizationContext"
import { useGivingPersonContext } from "../../hooks/useGivingPersonContext"

export default function Form() {
  const { givingOrganization } = useGivingOrganizationContext()
  const { paymentMethods } = usePaymentMethodsContext()
  const { givingPerson } = useGivingPersonContext()
  const text2GivePhoneNumber: Text2GivePhoneNumber =
    givingPerson.text_to_give_phone_number!

  const [selectedPaymentMethodId, setSelectedPaymentMethodId] =
    useState<string>("")
  const [isSaving, setIsSaving] = useState(false)
  const [hasErrors, setHasErrors] = useState(false)

  useEffect(() => {
    if (!selectedPaymentMethodId && paymentMethods) {
      const selectedPaymentMethod = paymentMethods.find(
        (paymentMethod) =>
          String(paymentMethod.id) === text2GivePhoneNumber.payment_method_id,
      )
      setSelectedPaymentMethodId(selectedPaymentMethod?.id || "")
    }
  }, [
    paymentMethods,
    text2GivePhoneNumber.payment_method_id,
    selectedPaymentMethodId,
  ])

  const handlePaymentMethodChange = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setIsSaving(true)
    setHasErrors(false)

    try {
      const response = await sessionApiClient.patch(
        "/giving/v2/me/text_to_give_phone_number",
        {
          data: {
            attributes: {
              payment_method_id: event.target.value,
            },
          },
        },
      )
      setSelectedPaymentMethodId(
        response.data.relationships.payment_method.data.id,
      )
    } catch (error) {
      setHasErrors(true)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className="d-f fd-c g-3">
      {hasErrors && (
        <AlertMessage type="error" icon="general#exclamation-triangle">
          Something went wrong. Please try again.
        </AlertMessage>
      )}
      <dl>
        <dt className="fs-4">Phone number:</dt>
        <dd className="fs-3 fw-600 c-tint1">
          {text2GivePhoneNumber.phone_number}
        </dd>
      </dl>
      <div className="d-f fd-c g-1">
        <div>
          <label htmlFor="payment_method_id" className="fs-4 fw-400">
            Text2Give payment method:
          </label>
          <div className="w-50%@md">
            <Select
              id="payment_method_id"
              name="payment_method_id"
              value={selectedPaymentMethodId}
              onChange={handlePaymentMethodChange}
              disabled={!givingOrganization.text2give_enabled || isSaving}
            >
              <>
                <Select.Option
                  value=""
                  disabled
                  label="Select payment method..."
                />
                {paymentMethods?.map(({ id, brand, last4 }) => (
                  <Select.Option
                    key={id}
                    value={id}
                    label={`${brand} ...${last4}`}
                  />
                ))}
              </>
            </Select>
          </div>
        </div>
        <Link to="/me/profile/payment-methods" className="fs-13 fw-500">
          Manage payment methods
        </Link>
      </div>
    </div>
  )
}
